export default "__VITE_PUBLIC_ASSET__5f87d6ff__"